module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('app-header', {
    attrs: {
      "icon": "bottle"
    }
  }, [_vm._v("\n        Régularisation\n    ")]), _vm._v(" "), _c('action-bar', {
    attrs: {
      "back": {
        name: 'bouteille',
        params: {
          id: _vm.bouteille.id
        }
      }
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "wrap",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendForm($event)
      }
    }
  }, [_c('h1', [_vm._v("QUANTITÉ ACTUELLE : " + _vm._s(_vm.bouteille.poids_net) + " / " + _vm._s(_vm.bouteille.poids_max) + " Kg")]), _vm._v(" "), _c('label', [_vm._v("Type de régularisation *")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.op.type),
      expression: "op.type",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "type-ajout",
      "type": "radio",
      "name": "type",
      "value": "6"
    },
    domProps: {
      "checked": _vm._q(_vm.op.type, _vm._n("6"))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.op, "type", _vm._n("6"))
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-radio",
    attrs: {
      "for": "type-ajout"
    }
  }, [_vm._v("\n                    Ajout\n                    "), _c('i', {
    staticClass: "icon-valid"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.op.type),
      expression: "op.type",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "type-retrait",
      "type": "radio",
      "name": "type",
      "value": "7"
    },
    domProps: {
      "checked": _vm._q(_vm.op.type, _vm._n("7"))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.op, "type", _vm._n("7"))
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-radio",
    attrs: {
      "for": "type-retrait"
    }
  }, [_vm._v("\n                    Retrait\n                    "), _c('i', {
    staticClass: "icon-valid"
  })])])]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("\n                Quantité corrigée *\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.op.quantity),
      expression: "op.quantity",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "step": "0.001",
      "min": "0",
      "id": "quantity"
    },
    domProps: {
      "value": (_vm.op.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.op, "quantity", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "comment"
    }
  }, [_vm._v("Commentaire *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.op.comment),
      expression: "op.comment"
    }],
    attrs: {
      "name": "comment",
      "id": "comment",
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.op.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.op, "comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Valider"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-945540a2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bouteille/BouteilleRegul.vue
// module id = 778
// module chunks = 0